import { z } from 'zod';

export const invoicePartnerSchema = z.object({
  id: z.number().default(-1),
  Invoice: z.number(),
  Partner: z.number(),
  selling_price: z.preprocess(
    (val) => {
      if (typeof val === 'string' || typeof val === 'number') {
        const num = Number(val);
        return isNaN(num) ? undefined : num;
      }
      return val;
    },
    z.number().default(0)
  ),
});

export type IInvoicePartner = z.infer<typeof invoicePartnerSchema>;